/* Aura (03/10/2026): "Find your size" da página de produto (snippet aura-find-size).
   - abre pelo link ao lado do SIZE GUIDE; fecha no X, fora da caixa e com Esc;
   - tamanho pelas faixas de altura (e de peso, quando a tabela tem) da tabela de medidas do produto,
     soma o ajuste do modelo (jogador +2) e a preferência (Tight -1, Loose +1) na lista de tamanhos do produto;
   - "Select this size" marca o tamanho na página e fecha.
   Mesma conta da prévia da rodada 5 (testada em torcedor, jogador e infantil). */
(function () {
  if (window.AuraFindSize) return;
  var CHAVE = 'aura-fys-unidade';
  var IMPERIAL = ['US', 'LR', 'MM'];
  var aberto = null, focoAntes = null, paisPromessa = null;

  /* ---------- textos traduzidos (Aura 05/10): o snippet publica em <script data-aura-i18n="find_size">; sem ele, fica o inglês ---------- */
  var TXT = null;
  function tx(k, reserva, vars) {
    if (TXT === null) {
      TXT = {};
      var el = document.querySelector('script[data-aura-i18n="find_size"]');
      if (el) { try { TXT = JSON.parse(el.textContent) || {}; } catch (e) { TXT = {}; } }
    }
    var s = TXT[k];
    if (typeof s !== 'string' || !s || /^translation missing/i.test(s)) s = reserva;
    if (vars) for (var v in vars) s = s.split('[' + v + ']').join(vars[v]);
    return s;
  }

  /* ---------- unidade dos campos ---------- */
  function lerSalvo() { try { return localStorage.getItem(CHAVE); } catch (e) { return null; } }
  function salvar(u) { try { localStorage.setItem(CHAVE, u); } catch (e) {} }
  function porIdioma() { var l = (navigator.languages && navigator.languages[0]) || navigator.language || ''; return /-US$/i.test(l) ? 'in' : 'cm'; }
  function detectarUnidade() {
    var s = lerSalvo();
    if (s === 'in' || s === 'cm') return Promise.resolve(s);
    if (!paisPromessa) {
      paisPromessa = fetch('/browsing_context_suggestions.json', { credentials: 'same-origin', headers: { accept: 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (j) { return j && j.detected_values && j.detected_values.country ? j.detected_values.country.handle : null; })
        .catch(function () { return null; });
    }
    return paisPromessa.then(function (p) { return p ? (IMPERIAL.indexOf(String(p).toUpperCase()) >= 0 ? 'in' : 'cm') : porIdioma(); });
  }

  /* ---------- números ---------- */
  function faixa(txt) {
    if (txt == null || txt === '') return null;
    var n = String(txt).replace(/,/g, '.').match(/\d+(?:\.\d+)?/g);
    if (!n || !n.length) return null;
    var a = parseFloat(n[0]), b = parseFloat(n[n.length - 1]);
    return a <= b ? [a, b] : [b, a];
  }
  function ftin(cm) { var t = Math.round(cm / 2.54), f = Math.floor(t / 12); return f + '′' + (t - f * 12) + '″'; }
  function textoAltura(cm, uni) { return uni === 'in' ? ftin(cm) : Math.round(cm) + ' cm'; }
  function textoPeso(kg, uni) { return uni === 'in' ? Math.round(kg * 2.20462) + ' lb' : (Math.round(kg * 2) / 2) + ' kg'; }

  /* ---------- tamanhos: nome e idade ---------- */
  function normTam(t) {
    var s = String(t || '').toUpperCase().replace(/\s+/g, '');
    if (s === 'XXXXL') return '4XL';
    if (s === 'XXXL') return '3XL';
    if (s === 'XXL') return '2XL';
    return s;
  }
  var UN = '(years?|yrs?|y|anos?|months?|meses|m)';
  var RE_FAIXA = new RegExp('(\\d+(?:\\.\\d+)?)\\s*' + UN + '?\\s*(?:-|to)\\s*(\\d+(?:\\.\\d+)?)\\s*' + UN + '(?![a-z])', 'i');
  var RE_UM = new RegExp('(\\d+(?:\\.\\d+)?)\\s*(years?|yrs?|anos?|months?|meses)(?![a-z])', 'i');
  function emMeses(u) { return /^(m|months?|meses)$/i.test(u || '') ? 1 : 12; }
  function meses(t) {
    var s = String(t || '');
    var m = s.match(RE_FAIXA);
    if (m) { var mu = emMeses(m[4]); var m1 = m[2] ? emMeses(m[2]) : mu; return [parseFloat(m[1]) * m1, parseFloat(m[3]) * mu]; }
    var u = s.match(RE_UM);
    if (u) { var k = emMeses(u[2]), v = parseFloat(u[1]) * k; return k === 12 ? [v, v + 12] : [v, v]; }
    return null;
  }
  function nota(rotulo, opcao) {
    if (normTam(rotulo) === normTam(opcao)) return 100;
    var a = meses(rotulo), b = meses(opcao);
    if (!a || !b) return 0;
    if (b[1] > b[0] && a[1] > a[0]) {
      var sob = Math.min(a[1], b[1]) - Math.max(a[0], b[0]);
      return sob > 0 ? 10 * sob / (a[1] - a[0] + b[1] - b[0] - sob) : 0;
    }
    if (b[0] === b[1]) {
      if (b[0] < a[0] || b[0] > a[1]) return 0;
      return 5 - Math.abs(b[0] - (a[0] + a[1]) / 2) / (a[1] - a[0] + 1);
    }
    if (a[0] === a[1]) return a[0] >= b[0] && a[0] <= b[1] ? 4 : 0;
    return 0;
  }

  /* ---------- seletor de tamanho da página ---------- */
  function campoTamanho() {
    var grupos = document.querySelectorAll('variant-selects fieldset, variant-selects .product-form__input--dropdown');
    for (var i = 0; i < grupos.length; i++) {
      var g = grupos[i];
      if (g.hasAttribute('data-aura-patch-oculta')) continue;
      var rot = g.querySelector('legend, label.form__label');
      var t = rot ? rot.textContent.replace(/[:\s]+/g, ' ').trim().toLowerCase() : '';
      if (t === 'size' || t === 'tamanho' || t === 'talla' || t === 'taille' || t === 'taglia' || t.indexOf('size') >= 0) return g;
    }
    return null;
  }
  function opcoes() {
    var fs = campoTamanho();
    if (!fs) return [];
    var ins = fs.querySelectorAll('input[type="radio"]');
    if (ins.length) return Array.prototype.map.call(ins, function (i) { return { valor: i.value, el: i }; });
    var sel = fs.querySelector('select');
    if (sel) return Array.prototype.map.call(sel.options, function (o) { return { valor: o.value, sel: sel }; });
    return [];
  }
  function opcaoDaLinha(rotulo, ops) {
    var melhor = -1, nm = 0;
    ops.forEach(function (o, i) { var n = nota(rotulo, o.valor); if (n > 0 && n >= nm) { nm = n; melhor = i; } });
    return melhor;
  }
  function marcar(o) {
    if (!o) return;
    if (o.sel) { o.sel.value = o.valor; o.sel.dispatchEvent(new Event('change', { bubbles: true })); return; }
    if (!o.el.checked) { o.el.checked = true; o.el.dispatchEvent(new Event('change', { bubbles: true })); }
  }

  /* ---------- faixas da tabela ---------- */
  function linhas(m) {
    if (m._linhas) return m._linhas;
    var el = m.querySelector('[data-aura-fys-dados]'), dados = null;
    try { dados = JSON.parse(el ? el.textContent : '{}'); } catch (e) { dados = null; }
    m._linhas = ((dados && dados.linhas) || []).map(function (l) { return { rotulo: l.r, h: faixa(l.h), w: faixa(l.w) }; });
    return m._linhas;
  }
  function posicao(ls, chave, v, tol) {
    var com = [];
    ls.forEach(function (l, i) { if (l[chave]) com.push({ i: i, f: l[chave] }); });
    if (!com.length || v == null) return null;
    if (v < com[0].f[0] - tol) return { fora: 'abaixo', primeiro: com[0].i };
    if (v > com[com.length - 1].f[1] + tol) return { fora: 'acima', ultimo: com[com.length - 1].i };
    for (var k = 0; k < com.length; k++) if (v <= com[k].f[1]) return { i: com[k].i };
    return { i: com[com.length - 1].i };
  }
  function indiceProduto(ls, base, ops) {
    if (!ops.length) return { j: -1 };
    for (var k = base; k < ls.length; k++) { var j = opcaoDaLinha(ls[k].rotulo, ops); if (j >= 0) return { j: j, subiu: k > base }; }
    var mb = meses(ls[base].rotulo);
    if (mb) {
      var cand = -1, ini = Infinity, temIdade = false;
      ops.forEach(function (o, i) { var mo = meses(o.valor); if (!mo) return; temIdade = true; if (mo[0] >= mb[0] && mo[0] < ini) { ini = mo[0]; cand = i; } });
      if (cand >= 0) return { j: cand, subiu: true };
      if (temIdade) return { pequeno: true };
    }
    for (var q = base - 1; q >= 0; q--) if (opcaoDaLinha(ls[q].rotulo, ops) >= 0) return { pequeno: true };
    return { j: -1 };
  }

  /* ---------- campos ---------- */
  function campo(form, n) { return form.querySelector('input[name="' + n + '"]'); }
  function num(el) { if (!el || el.value === '') return null; var v = parseFloat(String(el.value).replace(',', '.')); return isFinite(v) ? v : null; }
  function aplicarUnidade(m, uni) {
    var form = m.querySelector('.aura-fys__form');
    if (!form) return;
    var antes = form.getAttribute('data-uni');
    if (antes && antes !== uni) {
      var ft = campo(form, 'ft'), pol = campo(form, 'pol'), cm = campo(form, 'cm'), lb = campo(form, 'lb'), kg = campo(form, 'kg');
      if (antes === 'in') {
        if (num(ft) != null || num(pol) != null) cm.value = Math.round(((num(ft) || 0) * 12 + (num(pol) || 0)) * 2.54);
        if (lb && kg && num(lb) != null) kg.value = Math.round(num(lb) / 2.20462 * 2) / 2;
      } else {
        if (num(cm) != null) { var t = Math.round(num(cm) / 2.54); ft.value = Math.floor(t / 12); pol.value = t - Math.floor(t / 12) * 12; }
        if (lb && kg && num(kg) != null) lb.value = Math.round(num(kg) * 2.20462);
      }
    }
    form.setAttribute('data-uni', uni);
    form.querySelectorAll('[data-grupo]').forEach(function (g) { g.hidden = g.getAttribute('data-grupo') !== uni; });
    form.querySelectorAll('.aura-fys__uni').forEach(function (b) { var on = b.getAttribute('data-uni') === uni; b.classList.toggle('is-ativa', on); b.setAttribute('aria-pressed', on ? 'true' : 'false'); });
    if (m._ultimo) mostrar(m, m._ultimo);
  }

  /* ---------- recomendador ---------- */
  function calcular(m) {
    var form = m.querySelector('.aura-fys__form'), erro = form.querySelector('.aura-fys__erro');
    var uni = form.getAttribute('data-uni') || 'cm', ls = linhas(m);
    var temPeso = ls.some(function (l) { return l.w; });
    var hcm = null, kg = null;
    if (uni === 'in') {
      var ft = num(campo(form, 'ft')), pol = num(campo(form, 'pol'));
      if (ft || pol) hcm = ((ft || 0) * 12 + (pol || 0)) * 2.54;
      if (temPeso) { var lb = num(campo(form, 'lb')); if (lb) kg = lb / 2.20462; }
    } else {
      hcm = num(campo(form, 'cm'));
      if (temPeso) kg = num(campo(form, 'kg'));
    }
    var falta = [];
    if (!hcm) falta.push('height');
    if (temPeso && !kg) falta.push('weight');
    if (falta.length) { erro.textContent = falta.length > 1 ? tx('enter_height_weight', 'Please enter your height and weight.') : falta[0] === 'height' ? tx('enter_height', 'Please enter your height.') : tx('enter_weight', 'Please enter your weight.'); erro.hidden = false; return; }
    erro.hidden = true;
    var fitEl = form.querySelector('.aura-fys__fit-op.is-ativa');
    var fit = fitEl ? parseInt(fitEl.getAttribute('data-fit'), 10) || 0 : 0;
    var somar = parseInt(m.getAttribute('data-somar'), 10) || 0;
    var ops = opcoes();
    var comH = ls.filter(function (l) { return l.h; });
    var h = posicao(ls, 'h', hcm, 4), w = temPeso ? posicao(ls, 'w', kg, 6) : null;
    var r = { hcm: hcm, kg: kg, fit: fit, somar: somar };
    var alturaTxt = function (cm) { return uni === 'in' ? ftin(cm) : cm + ' cm'; };

    if (!h) return fora(m, tx('no_height_ranges', 'This size chart has no height ranges to compare with.'));
    var maiores = function (aPartirDe) {
      var j = aPartirDe >= 0 ? opcaoDaLinha(ls[aPartirDe].rotulo, ops) : -1;
      return j >= 0 && j < ops.length - 1 ? ops.slice(j + 1).map(function (o) { return o.valor; }) : [];
    };
    if (h.fora === 'acima') {
      var ult = comH[comH.length - 1], extra = maiores(h.ultimo);
      return fora(m, tx('height_above', 'Your height is above this size chart, which goes up to [size] ([height]).', { size: ult.rotulo, height: alturaTxt(ult.h[1]) }) + (extra.length ? ' ' + tx('also_comes_in', 'This product also comes in [sizes].', { sizes: extra.join(', ') }) : ''));
    }
    var cand = [], aviso = '';
    if (!h.fora) cand.push(h.i);
    if (w && !w.fora) cand.push(w.i);
    if (w && w.fora === 'acima') {
      if (w.ultimo < ls.length - 1) { cand.push(w.ultimo + 1); aviso = tx('weight_above_note', 'Above [weight] this chart lists sizes by measurements only, so please compare the width with a jersey that fits you.', { weight: textoPeso(ls[w.ultimo].w[1], uni) }); }
      else return fora(m, tx('weight_above', 'Your weight is above the largest size of this chart.'));
    }
    if (!cand.length) {
      var pri = comH[0];
      return fora(m, tx('height_below', 'Your height is below this size chart, which starts at [size] ([height]).', { size: pri.rotulo, height: alturaTxt(pri.h[0]) }));
    }
    var base = Math.max.apply(null, cand);
    var ip = indiceProduto(ls, base, ops);
    if (ip.pequeno) return fora(m, tx('largest_too_small', 'The largest size of this product is [size], which is too small for these measurements.', { size: ops[ops.length - 1].valor }));
    var j = ip.j;
    if (ip.subiu && j >= 0) aviso = aviso || tx('not_in_size', 'This product does not come in [size], so this is the closest size up.', { size: ls[base].rotulo });
    if (j < 0 || !ops.length) {
      var alvo = Math.min(Math.max(base + fit + somar, 0), ls.length - 1);
      r.nome = ls[alvo].rotulo; r.opcao = null; r.aviso = aviso;
      return mostrar(m, r);
    }
    var fim = j + somar + fit;
    if (j + somar > ops.length - 1) return fora(m, tx('largest_too_small_cut', 'The largest size of this product is [size], and with this cut it would be too small for your measurements.', { size: ops[ops.length - 1].valor }));
    if (fim > ops.length - 1) { fim = ops.length - 1; aviso = aviso || tx('is_largest', 'This is the largest size of this product.'); }
    if (fim < 0) { fim = 0; aviso = aviso || tx('is_smallest', 'This is the smallest size of this product.'); }
    r.opcao = ops[fim]; r.nome = ops[fim].valor; r.aviso = aviso;
    mostrar(m, r);
  }
  function rolarAteResultado(m, res) {
    var caixa = m.querySelector('.aura-fys__caixa');
    if (!caixa || !res) return;
    var cb = caixa.getBoundingClientRect(), rb = res.getBoundingClientRect();
    if (rb.bottom > cb.bottom) caixa.scrollTo({ top: caixa.scrollTop + (rb.bottom - cb.bottom) + 16, behavior: 'smooth' });
  }
  function mostrar(m, r) {
    var form = m.querySelector('.aura-fys__form'), uni = form.getAttribute('data-uni') || 'cm';
    var res = m.querySelector('.aura-fys__res'), ok = m.querySelector('.aura-fys__res-ok'), f = m.querySelector('.aura-fys__res-fora');
    res.hidden = false; f.hidden = true; ok.hidden = false;
    var tam = ok.querySelector('[data-res-tam]');
    tam.textContent = r.nome;
    tam.classList.toggle('is-longo', String(r.nome).length > 4);
    var fitTxt = r.fit < 0 ? tx('fit_tight', 'tight') : r.fit > 0 ? tx('fit_loose', 'loose') : tx('fit_regular', 'regular');
    var partes = [r.kg ? tx('based_on_height_weight', 'Based on [height] and [weight], [fit] fit.', { height: textoAltura(r.hcm, uni), weight: textoPeso(r.kg, uni), fit: fitTxt }) : tx('based_on_height', 'Based on [height], [fit] fit.', { height: textoAltura(r.hcm, uni), fit: fitTxt })];
    if (r.somar > 0) partes.push(r.somar > 1 ? tx('already_up_player_other', 'Already [count] sizes up for the slim player cut.', { count: r.somar }) : tx('already_up_player_one', 'Already [count] size up for the slim player cut.', { count: r.somar }));
    if (r.aviso) partes.push(r.aviso);
    if (!r.opcao) partes.push(tx('pick_matching', 'Pick the matching size in the options on the page.'));
    ok.querySelector('[data-res-txt]').textContent = partes.join(' ');
    ok.querySelector('[data-escolher]').hidden = !r.opcao;
    m._ultimo = r;
    rolarAteResultado(m, res);
  }
  function fora(m, txt) {
    var res = m.querySelector('.aura-fys__res'), ok = m.querySelector('.aura-fys__res-ok'), f = m.querySelector('.aura-fys__res-fora');
    res.hidden = false; ok.hidden = true; f.hidden = false;
    f.querySelector('[data-fora-txt]').textContent = txt;
    m._ultimo = null;
    rolarAteResultado(m, res);
  }

  /* ---------- janela ---------- */
  function abrir(m) {
    if (!m) return;
    if (m.parentNode !== document.body) document.body.appendChild(m);
    var form = m.querySelector('.aura-fys__form');
    if (form && !form._iniciado) {
      form._iniciado = true;
      aplicarUnidade(m, lerSalvo() || porIdioma());
      detectarUnidade().then(function (u) { if (!lerSalvo() && u !== form.getAttribute('data-uni')) aplicarUnidade(m, u); });
    }
    focoAntes = document.activeElement;
    m.hidden = false;
    document.documentElement.classList.add('aura-fys-travado');
    aberto = m;
    requestAnimationFrame(function () {
      m.classList.add('is-aberto');
      var x = m.querySelector('.aura-fys__x');
      if (x) x.focus({ preventScroll: true });
    });
  }
  function fechar(m) {
    if (!m) return;
    m.classList.remove('is-aberto');
    m.hidden = true;
    document.documentElement.classList.remove('aura-fys-travado');
    aberto = null;
    if (focoAntes && focoAntes.focus) try { focoAntes.focus({ preventScroll: true }); } catch (e) {}
  }
  function escolher(m) {
    var r = m._ultimo;
    if (!r || !r.opcao) return;
    marcar(r.opcao);
    fechar(m);
    var fs = campoTamanho();
    if (fs) { var b = fs.getBoundingClientRect(); if (b.top < 80 || b.bottom > window.innerHeight) window.scrollTo({ top: window.scrollY + b.top - 140, behavior: 'smooth' }); }
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var ab = t.closest('[data-aura-fys-abrir]');
    if (ab) {
      e.preventDefault();
      var id = ab.getAttribute('aria-controls');
      abrir((id && document.getElementById(id)) || (ab.parentNode && ab.parentNode.querySelector('[data-aura-fys]')));
      return;
    }
    var m = t.closest('[data-aura-fys]');
    if (!m) return;
    if (t === m || t.closest('[data-aura-fys-fechar]')) { fechar(m); return; }
    var u = t.closest('.aura-fys__uni');
    if (u) { var uni = u.getAttribute('data-uni'); salvar(uni); aplicarUnidade(m, uni); return; }
    var fo = t.closest('.aura-fys__fit-op');
    if (fo) { m.querySelectorAll('.aura-fys__fit-op').forEach(function (b) { var on = b === fo; b.classList.toggle('is-ativa', on); b.setAttribute('aria-checked', on ? 'true' : 'false'); }); return; }
    if (t.closest('[data-escolher]')) escolher(m);
  });
  document.addEventListener('submit', function (e) {
    var f = e.target && e.target.closest && e.target.closest('.aura-fys__form');
    if (!f) return;
    e.preventDefault();
    var m = f.closest('[data-aura-fys]');
    if (m) calcular(m);
  });
  document.addEventListener('keydown', function (e) { if (aberto && e.key === 'Escape') fechar(aberto); });

  window.AuraFindSize = { meses: meses, nota: nota, abrir: abrir, fechar: fechar };
})();
